import { getRequest, postRequest } from "../../shared/api/axiosHandler";

export const submitOrderComplaint = async (complaint) => {
  try {
    return await postRequest('/public/complaint', complaint);
  } catch (error) {
    throw error;
  }
};

export const trackOrder = async (orderId) => {
  try {
    return await getRequest(`/public/ordertracking/${orderId}`);
  } catch (error) {
    throw error;
  }
};

export const getMaskedBillingPhone = async (orderNumber) => {
  try {
    return await getRequest(`/public/ordertracking/${orderNumber}/billing/phone`);
  } catch (error) {
    throw error;
  }
};

export const trackOrderByVerifying = async (orderId, lastFour) => {
  try {
    return await getRequest(`/public/ordertracking/${orderId}/billing-phone-verification?lastFour=${lastFour}`);
  } catch (error) {
    throw error;
  }
}

export const trackOrderByCustomerTrackingId = async (customerTrackingId) => {
  try {
    return await getRequest(`/public/ordertracking?customerTrackingId=${customerTrackingId}`);
  } catch (error) {
    throw error;
  }
};

export const getOrders = async (page = 0, size = 5, status = '', dateFilter = '') => {
    try {
        let queryParams = `?page=${page}&size=${size}`;
        if (status) {
            queryParams += `&status=${encodeURIComponent(status)}`;
        }
        if (dateFilter) {
            queryParams += `&dateFilter=${encodeURIComponent(dateFilter)}`;
        }
       // console.log(queryParams);
        return await getRequest(`/api/v1/orders${queryParams}`, {}, true);
    } catch (error) {
        throw error;
    }
};

export const getOrderbyId = async (orderId) => {
    try {
        return await getRequest(`/api/v1/orders/${orderId}`, {}, true);
    } catch (error) {
        throw error;
    }
};
